class TopProductsCarousel extends HTMLElement {
  constructor() {
    super();

    this.list = this.querySelector('[data-top-products-carousel-list]');
    this.previousButton = this.querySelector('[data-top-products-carousel-previous]');
    this.nextButton = this.querySelector('[data-top-products-carousel-next]');
    this.updateArrows = this.updateArrows.bind(this);

    if (!this.list) {
      return;
    }

    initCarouselScroll(this.list, {
      draggingClass: 'top-products-carousel__list--dragging',
      onScroll: this.updateArrows,
    });

    if (this.previousButton) {
      this.previousButton.addEventListener('click', this.onArrowClick.bind(this, 'previous'));
    }

    if (this.nextButton) {
      this.nextButton.addEventListener('click', this.onArrowClick.bind(this, 'next'));
    }

    window.addEventListener('resize', this.updateArrows);
    this.updateArrows();
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.updateArrows);
  }

  onArrowClick(direction) {
    const item = this.list.querySelector('.top-products-carousel__item');
    const gap = parseFloat(window.getComputedStyle(this.list).columnGap) || 0;
    const scrollAmount = item ? item.getBoundingClientRect().width + gap : this.list.clientWidth;

    this.list.scrollBy({
      left: direction === 'next' ? scrollAmount : -scrollAmount,
      behavior: 'smooth',
    });

    window.setTimeout(this.updateArrows, 350);
  }

  updateArrows() {
    if (!this.previousButton || !this.nextButton) {
      return;
    }

    const maxScroll = this.list.scrollWidth - this.list.clientWidth;
    const isScrollable = maxScroll > 1;
    const slider = this.list.closest('.top-products-carousel__slider');

    if (slider) {
      slider.classList.toggle('top-products-carousel__slider--arrows-visible', isScrollable);
    }
    this.previousButton.hidden = !isScrollable;
    this.nextButton.hidden = !isScrollable;
    this.previousButton.disabled = this.list.scrollLeft <= 1;
    this.nextButton.disabled = this.list.scrollLeft >= maxScroll - 1;
  }
}

if (!customElements.get('top-products-carousel')) {
  customElements.define('top-products-carousel', TopProductsCarousel);
}
